import { AgingBase } from "./ARAging";

export default function APAging() {
    return <AgingBase
        url="/reports/ap-aging"
        kicker="REPORTS • PAYABLES"
        title="AP Aging"
        subtitle="Outstanding payables by aging bucket."
        partyKey="vendor_name"
        partyLabel="Vendor"
        fileBase="AP_Aging"
        testIdPrefix="ap"
    />;
}
